// extracted by mini-css-extract-plugin
export default {"Container":"links_Container__b8czN","Status-active":"links_Status-active__FGC3x","Status-inactive":"links_Status-inactive__vqYZg","balance":"links_balance__i8mpx"};